import { ReactNode } from 'react';

import { Typography } from '../Typography';

import styles from './Modal.module.scss';

interface ModalProps {
    label: string;
    description?: string;
    approveComponent: React.ReactElement;
    cancelComponent: React.ReactElement;
    width?: number;
    onClick: () => void;
    children?: ReactNode;
}

export const Modal: React.FC<ModalProps> = ({
    label,
    description = false,
    approveComponent,
    cancelComponent,
    width = 400,
    onClick,
    children,
}) => {
    return (
        <div className={styles.modal} onClick={onClick}>
            <div
                className={styles.container}
                style={{ width }}
                onClick={(e) => {
                    e.stopPropagation();
                }}
            >
                <div className={styles.label}>
                    <Typography variant="h4" className={styles.type}>
                        {label}
                    </Typography>
                </div>
                {description && (
                    <div className={styles.description}>
                        <Typography variant="subheading">{description}</Typography>
                    </div>
                )}
                {children}
                <div className={styles.buttons}>
                    {cancelComponent}
                    {approveComponent}
                </div>
            </div>
        </div>
    );
};
